import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const AnalyticsAirportRegionRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--analytics--airport-region']}>
    <Route index element={<Index />} />
  </SubRouter>
))
